module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Bold.82dfc9f.woff2";